export default {
	"home.AnErrorHasOccurredPleaseContactTheInstructorForTheScreenshot": "An error has occurred, please contact the instructor for the screenshot",
	"home.MarketingMarketplaceHomePage": "Marketing Marketplace Home Page",
	"home.MarketingMarketplace": "Marketing Marketplace"
}